<template>
  <div>
    <div class="form-group">
      <select v-model="selectedStage" class="form-control">
        <option v-for="stage in stages" :key="stage.id" :value="stage.id">
          {{ stage.name }} ({{ `${dayjs(stage.start_at).format('L')} ${dayjs(stage.start_at).format('LT')}` }} -> {{ `${dayjs(stage.end_at).format('L')} ${dayjs(stage.end_at).format('LT')}` }})
        </option>
      </select>
    </div>
    <div class="form-group">
      <select v-model="selectedSlot"  class="form-control">
        <option v-for="bookingSlot in stages.find((s) => s.id === selectedStage)?.booking_slots" :key="bookingSlot.id" :value="bookingSlot.id">
          {{ `${dayjs(bookingSlot.start_at).format('L')} ${dayjs(bookingSlot.start_at).format('LT')}` }} -> {{ `${dayjs(bookingSlot.end_at).format('L')} ${dayjs(bookingSlot.end_at).format('LT')}` }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import { onMounted, ref, watch } from "vue";

const props = defineProps({
  stages: {
    type: Array,
    required: true
  },
  booking: {
    type: Object,
    default : null,
  },
})

const emit = defineEmits(['slotSelected'])

watch(
  () => props.booking,
  (newVal) => {
    if (newVal) {
      emit('slotSelected', newVal.booking_slot)
    }
  }
)

const selectedStage = ref(props.booking?.booking_slot?.stage_id ?? props.stages[0]?.id ?? null)

// The <select> shows the first slot of the stage as picked, so start from it rather than from
// null: otherwise saving without touching the dropdowns would submit no slot at all.
const defaultSlot = props.stages.find((s) => s.id === selectedStage.value)?.booking_slots?.[0]
const selectedSlot = ref(props.booking?.booking_slot?.id ?? defaultSlot?.id ?? null)

onMounted(() => {
  if (selectedSlot.value) {
    emit('slotSelected', findSlot(selectedSlot.value))
  }
})

function findSlot(slotId) {
  return props.stages
    .find((s) => s.id === selectedStage.value)
    ?.booking_slots
    ?.find((bs) => bs.id === slotId) ?? null
}

watch(
  () => selectedStage.value,
  (newVal) => {
    const stage = props.stages.find((s) => s.id === newVal)
    if (stage) {
      selectedSlot.value = stage.booking_slots[0]?.id ?? null
    } else {
      selectedSlot.value = null
    }
  },
)

watch(
  () => selectedSlot.value,
  (newVal) => {
    const stage = props.stages.find((s) => s.id === selectedStage.value)
    if (stage) {
      const bookingSlot = stage.booking_slots.find((bs) => bs.id === newVal)
      emit('slotSelected', bookingSlot)
    } else {
      emit('slotSelected', null)
    }
  }
)
</script>